{
  "name": "psa-track-trace",
  "version": "3.0.0",
  "license": "MIT",
  "engines": {
    "node": "24.18.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:prod": "ng build --configuration=production",
    "build:dev": "ng build --configuration=dev",
    "build:inte": "ng build --configuration=inte",
    "lint": "eslint src --fix && npm run format",
    "format": "prettier --write \"src/**/*.{js,json,md,ts,html,scss}\"",
    "dev": "ng serve --configuration=dev",
    "int": "ng serve --configuration=inte",
    "prod": "ng serve --configuration=production",
    "deploy:prod": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=production && bluemix app push -f manifest-prod.yml",
    "deploy:dev": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=dev && bluemix app push -f manifest.yml",
    "deploy:inte": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=inte && bluemix app push -f manifest-inte.yml",
    "prepare": "npx husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.0.8",
    "@angular/cdk": "^22.0.6",
    "@angular/common": "22.0.8",
    "@angular/compiler": "22.0.8",
    "@angular/core": "22.0.8",
    "@angular/forms": "22.0.8",
    "@angular/material": "^22.0.6",
    "@angular/platform-browser": "22.0.8",
    "@angular/platform-browser-dynamic": "22.0.8",
    "@angular/router": "22.0.8",
    "@auth0/angular-jwt": "^5.1.0",
    "@bluehalo/ngx-leaflet": "^22.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@types/leaflet": "^1.9.12",
    "@types/leaflet.heat": "^0.2.4",
    "@types/leaflet.markercluster": "^1.0.3",
    "angular-plotly.js": "^6.0.0",
    "angular-svg-icon": "^19.1.1",
    "bcryptjs": "^2.4.3",
    "buffer": "^6.0.3",
    "file-saver": "^1.3.3",
    "leaflet": "1.9.3",
    "leaflet-arrowheads": "^1.4.0",
    "leaflet-textpath": "^1.2.3",
    "leaflet.heat": "^0.2.0",
    "leaflet.markercluster": "^1.4.1",
    "moment": "^2.29.4",
    "pako": "^2.0.3",
    "plotly.js": "^2.16.5",
    "plotly.js-dist-min": "^2.33.0",
    "psa-tnt-models": "git+https://TrackAndTrace:glpat-cXNRM0aKLdqPRqRc_Jzejm86MQp1OjF5a2QK.01.101ml21qb@git.eu-gb.bluemix.net/psa-tnt/models.git#v2.0.0",
    "rxjs": "7.8.2",
    "sass": "^1.56.1",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.0.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.0.8",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.0.8",
    "@angular/cli": "^22.0.8",
    "@angular/compiler-cli": "22.0.8",
    "@angular/language-service": "22.0.8",
    "@eslint/js": "^10.0.1",
    "@types/node": "^24.5.0",
    "@types/plotly.js": "^3.0.10",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.8.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "husky": "^8.0.3",
    "lint-staged": "13.2.0",
    "prettier": "^3.2.5",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.65.0"
  },
  "overrides": {
    "tar": "^7.5.22",
    "brace-expansion": "^5.0.8",
    "cacache": "^21.0.1",
    "glob": "^13.0.6",
    "minimatch": "^10.2.6",
    "pacote": "^22.0.0",
    "@hono/node-server": "^2.0.12",
    "@modelcontextprotocol/sdk": "^1.30.0",
    "postcss": "^8.5.24",
    "webpack-dev-server": "^6.0.0",
    "uuid": "^11.1.1"
  },
  "browser": {
    "crypto": false
  },
  "lint-staged": {
    "*.{js,ts}": [
      "eslint --fix"
    ],
    "*.{js,ts,json,md,html,scss}": [
      "prettier --write"
    ]
  },
  "volta": {
    "node": "24.18.0"
  },
  "allowScripts": {
    "@parcel/watcher": true,
    "es5-ext": true,
    "esbuild": true,
    "lmdb": true,
    "msgpackr-extract": true,
    "psa-tnt-models": true
  }
}
